import { parseServerDateTime } from './online-game-state.js';

export const DISCONNECT_GRACE_MILLISECONDS = 60_000;
const HIDDEN = Object.freeze({ visible: false, ready: false, seconds: 0, availableAt: null });
const timestamp = value => typeof value === 'number'
  ? Number.isFinite(value) ? value : null
  : parseServerDateTime(value);

/** Evaluate against the live clock, never a smoothed display or the viewer's time. */
export function getDisconnectClaimState(state, now = Date.now()) {
  if (!state || state.status !== 'Active' || !state.clockStarted || state.isSpectator
    || !Number.isFinite(state.opponentMilliseconds) || state.opponentMilliseconds < DISCONNECT_GRACE_MILLISECONDS
    || !(state.viewerMilliseconds > 0)) return HIDDEN;
  const disconnectedAt = timestamp(state.opponentDisconnectedAtUtc);
  if (disconnectedAt === null || !Number.isFinite(now)) return HIDDEN;
  const officialDeadline = timestamp(state.disconnectClaimAvailableAtUtc);
  const availableAt = Math.max(disconnectedAt + DISCONNECT_GRACE_MILLISECONDS, officialDeadline ?? 0);
  const seconds = Math.max(0, Math.ceil((availableAt - now) / 1000));
  return { visible: true, ready: now >= availableAt, seconds, availableAt };
}
